import {CardSim} from 'lucide-react';
import {useTranslation} from 'react-i18next';

import {usePath} from 'hooks';
import {PATHS} from 'Routes';
import {Button} from '@chekin/guestapp-ui-kit';
import {useNavigate} from 'react-router-dom';

export const EsimActionsCard = () => {
  const {t} = useTranslation();
  const {getFullPath} = usePath();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-6 p-4 rounded-2xl border border-[hsl(var(--border))] bg-[var(--navigation-background)]">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <CardSim size={20} />
          <span className="font-medium">{t('esim.manage.what_is_esim_title')}</span>
        </div>
        <div className="text-sm leading-6">
          {t('esim.manage.what_is_esim_description')}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Button onClick={() => navigate(getFullPath(PATHS.esim.choosePlan))}>
          {t('esim.manage.get_my_esim_button')}
        </Button>
        <Button
          className="font-medium"
          onClick={() => navigate(getFullPath(PATHS.esim.my))}
          variant={'outline'}
        >
          {t('esim.manage.my_esims_button')}
        </Button>
      </div>
    </div>
  );
};
